export var ModalMode;
(function (ModalMode) {
    ModalMode["Create"] = "create";
    ModalMode["Edit"] = "edit";
    ModalMode["Duplicate"] = "duplicate";
})(ModalMode || (ModalMode = {}));
//# sourceMappingURL=modalMode.enum.js.map